import { ofType } from 'redux-observable';
import { itineraryService } from '../../../mulesoftService/itineraryDetails/itineraryService';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  itineraryDetailsRequest,
  itineraryDetailsSuccess,
  itineraryDetailsFailure,
  itineraryExcursionsRequest,
  itineraryExcursionsSuccess,
  itineraryExcursionsFailure,
} from '../../slices/itinerarySlice';
import {
  portsGalleryFailure,
  portsGalleryRequest,
  portsGallerySuccess,
} from '../../slices/portsGallerySlice';

/**
 * Epic for handling itinerary details requests.
 * This epic listens for actions of the type `itineraryDetailsRequest.type`, then
 * performs an asynchronous request to fetch itinerary details using `itineraryService`.
 * Upon successful retrieval of itinerary details, it dispatches `itineraryDetailsSuccess`
 * action with the response payload. If the request fails, it dispatches `itineraryDetailsFailure`
 * action with the error message.
 *
 * @param action$ - Stream of Redux actions.
 * @returns Stream that emits either itineraryDetailsSuccess or itineraryDetailsFailure actions.
 */
export const itineraryDetailsEpic = (action$: any) =>
  action$.pipe(
    ofType(itineraryDetailsRequest.type),
    mergeMap((action: { payload: any }) =>
      from(itineraryService.performItineraryDetails(action.payload)).pipe(
        map((response) => itineraryDetailsSuccess(response)),
        catchError((error) => of(itineraryDetailsFailure(error.message)))
      )
    )
  );

/**
 * Epic for handling itinerary excursions requests.
 * This epic listens for actions of the type `itineraryExcursionsRequest.type`, then
 * performs an asynchronous request to fetch itinerary excursions using `itineraryService`.
 * Upon successful retrieval of itinerary excursions, it dispatches `itineraryExcursionsSuccess`
 * action with the response payload. If the request fails, it dispatches `itineraryExcursionsFailure`
 * action with the error message.
 *
 * @param action$ - Stream of Redux actions.
 * @returns Stream that emits either itineraryExcursionsSuccess or itineraryExcursionsFailure actions.
 */
export const itineraryExcursionsEpic = (action$: any) =>
  action$.pipe(
    ofType(itineraryExcursionsRequest.type),
    mergeMap((action: { payload: any }) =>
      from(itineraryService.performItineraryExcursions(action.payload)).pipe(
        map((response) => itineraryExcursionsSuccess(response)),
        catchError((error) => of(itineraryExcursionsFailure(error.message)))
      )
    )
  );

/**
 * Epic for handling itinerary details requests.
 * This epic listens for actions of the type `itineraryDetailsRequest.type`, then
 * performs an asynchronous request to fetch itinerary details using `itineraryService`.
 * Upon successful retrieval of itinerary details, it dispatches `itineraryDetailsSuccess`
 * action with the response payload. If the request fails, it dispatches `itineraryDetailsFailure`
 * action with the error message.
 *
 * @param action$ - Stream of Redux actions.
 * @returns Stream that emits either itineraryDetailsSuccess or itineraryDetailsFailure actions.
 */
export const itineraryPortsGalleryEpic = (action$: any) =>
  action$.pipe(
    ofType(portsGalleryRequest.type),
    mergeMap((action: { payload: any }) =>
      from(itineraryService.performItineraryDetails(action.payload)).pipe(
        map((response) => portsGallerySuccess(response)),
        catchError((error) => of(portsGalleryFailure(error.message)))
      )
    )
  );
